import { Link, useLocation } from 'react-router-dom'
import { useUserStore } from '@/stores/userStore'
import { SettingsIcon } from '@/components/ui/Icons'

export default function Header() {
  const location = useLocation()
  const { profile } = useUserStore()

  // Get page title and icon based on route
  const getPageInfo = () => {
    const path = location.pathname

    if (path === '/') return { title: 'Dashboard', subtitle: 'Overview' }
    if (path === '/logbook') return { title: 'Logbook', subtitle: 'Workouts' }
    if (path.startsWith('/workout')) return { title: 'Workout', subtitle: 'Session' }
    if (path === '/cycle') return { title: 'Cycle', subtitle: 'Planner' }
    if (path === '/settings') return { title: 'Settings', subtitle: 'Preferences' }

    return { title: 'X-Frame', subtitle: '' }
  }

  const { title } = getPageInfo()

  // Format current date
  const today = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'short',
    day: 'numeric',
  })

  return (
    <header className="sticky top-0 z-40 safe-top">
      {/* Glass background */}
      <div className="absolute inset-0 bg-background/70 backdrop-blur-xl" />

      {/* Bottom border with gradient */}
      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-border to-transparent" />

      <div className="relative flex items-center justify-between px-4 py-3">
        {/* Left: Logo/Title */}
        <div className="flex items-center gap-3">
          <Link to="/" className="flex items-center gap-3 group">
            {/* Logo */}
            <div className="relative w-10 h-10 rounded-xl overflow-hidden shadow-lg shadow-primary/20 group-hover:shadow-primary/30 transition-shadow">
              <img
                src="/icons/icon-header-logo.png"
                alt="X-Frame"
                className="w-full h-full object-cover"
              />
            </div>

            <div>
              <h1 className="text-lg font-bold text-text-primary leading-none">
                {title}
              </h1>
              <p className="text-xs text-text-muted mt-0.5">{today}</p>
            </div>
          </Link>
        </div>

        {/* Right: Phase badge + Settings */}
        <div className="flex items-center gap-2">
          {profile && (
            <Link
              to="/settings"
              className="hidden sm:flex items-center gap-2 px-3 py-1.5 bg-elevated/50 hover:bg-elevated rounded-full transition-colors"
            >
              <div className="flex items-center gap-1.5">
                <div className="w-2 h-2 bg-primary rounded-full animate-pulse" />
                <span className="text-xs font-semibold text-text-primary">
                  P{profile.current_phase}
                </span>
                <span className="text-xs text-text-muted">·</span>
                <span className="text-xs text-text-secondary">
                  W{profile.current_week}
                </span>
              </div>
            </Link>
          )}

          <Link
            to="/settings"
            className="p-2.5 rounded-xl text-text-muted hover:text-text-primary hover:bg-elevated/50 active:scale-95 transition-all"
            aria-label="Settings"
          >
            <SettingsIcon className="w-5 h-5" />
          </Link>
        </div>
      </div>
    </header>
  )
}
